import React, { Component } from 'react'
import '../styles/LostAsylum.css'
import Navbar from './Navbar'
import BookingContainer from './BookingContainer'
import Footer from './Footer'
import LACover from '../images/Themes/LA/la-cover.jpg'
import LACoverMobile from '../images/Themes/LA/mobile-lostasylum-cover.jpg'
import LAVideo2 from '../images/Themes/LA/la-cover-video.jpg'
import LAPicture1 from '../images/Themes/LA/la-picture-1.jpg'
import LAPicture2 from '../images/Themes/LA/la-picture-2.jpg'
import LAPicture3 from '../images/Themes/LA/la-picture-3.jpg'
import VBNPicture1 from '../images/Themes/VBN/vbn-picture-1.jpg'
import TombeauPicture1 from '../images/Themes/Tombeau/Tombeau-picture-1.jpg'
import AbattoirPicture1 from '../images/Themes/Abattoir/abattoir-picture-1.jpg'
import YakuzaPicture1 from '../images/Themes/Yakuza/yakuza-picture-1.jpg'
import MagnifierIcon from '../images/Themes/magnifier-icon.png'
import GlobeIcon from '../images/Themes/globe-icon.png'
import StarIcon from '../images/Themes/star-icon.png'
import PlayerIcon from '../images/Themes/player-icon.png'
import FearEmoji from '../images/Themes/LA/fear-emoji.png'
import { Link } from 'react-router-dom'
import DeferredYouTubePlayer from './DeferredYouTubePlayer'
import { injectIntl, defineMessages } from 'react-intl'
import Helmet from 'react-helmet'
import RoomSeoSection, { getRoomSeoContent } from './RoomSeoSection'
import ThemeHeroImage from './ThemeHeroImage'
import { buildRoomStructuredData } from '../structuredData'

const BackgroundUrl = `url(${LACover})`;
const BackgroundUrlMobile = `url(${LACoverMobile})`;

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

class LostAsylum extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTop: true,
      videoPlaying: false,
      smallVideoPlaying: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }
  render() {
    const {intl:{formatMessage}} = this.props

    return (
      <div className="theme lost-asylum">
        <Helmet>
          <title>Lost Asylum : l'escape game épouvante à Paris</title>
          <meta name="description" content="Découvrez Lost Asylum, notre escape game épouvante à Paris. En équipe de 2 à 5 joueurs, Lost Asylum vous fera frisonner dans les murs maudits de cet hôpital psychiatrique abandonné" />
			<meta property="og:type" content="website"/>
			<meta property="og:url" content="https://www.one-hour.fr/lost-asylum/"/>
			<meta property="og:title" content="Lost Asylum : l'escape game épouvante à Paris"/>
			<meta property="og:description" content="Découvrez Lost Asylum, notre escape game épouvante à Paris. En équipe de 2 à 5 joueurs, Lost Asylum vous fera frisonner dans les murs maudits de cet hôpital psychiatrique abandonné"/>
			<meta property="og:image" content="https://www.one-hour.fr/static/media/pressen-5.jpg"/>
			<meta property="twitter:card" content="summary_large_image"/>
			<meta property="twitter:url" content="https://www.one-hour.fr/lost-asylum/"/>
			<meta property="twitter:title" content="Lost Asylum : l'escape game épouvante à Paris"/>
			<meta property="twitter:description" content="Découvrez Lost Asylum, notre escape game épouvante à Paris. En équipe de 2 à 5 joueurs, Lost Asylum vous fera frisonner dans les murs maudits de cet hôpital psychiatrique abandonné"/>
			<meta property="twitter:image" content="https://www.one-hour.fr/static/media/pressen-5.jpg"/>
			<link rel="apple-touch-icon" href="https://www.one-hour.fr/static/media/apple-touch-icon.png" />
			<html lang={this.props.lang || 'fr'} />
            <script type="application/ld+json">{JSON.stringify(buildRoomStructuredData({ roomKey: 'lostAsylum', faq: getRoomSeoContent('lostAsylum', this.props.lang).faq, lang: this.props.lang }))}</script>
        </Helmet>
        <div className="theme-hero">
          <Navbar
            isTop={this.state.isTop}
            handleLang={(lang) => this.props.handleLang(lang)}
            lang={this.props.lang}
            />
          <div className="theme-hero-cover theme-d-background" style={{ '--background-url': BackgroundUrl, '--background-url-mobile':BackgroundUrlMobile }}>
          <ThemeHeroImage desktop={LACover} mobile={LACoverMobile} />
          {
            this.state.videoPlaying
            ?
              <DeferredYouTubePlayer videoId="dtsJLKARMMQ" title="Trailer Lost Asylum" />
              : null
          }
          </div>
          {
            !this.state.videoPlaying
            ?
            <div className="theme-title">
              <div className="title">Lost Asylum</div>
              <div className="play-video-button" onClick={() => this.setState({ videoPlaying: true })}>
                <span>{formatMessage(messages.playVideo)}</span>
                <span className="play-video-icon">
                  <span className="play-video-triangle" aria-hidden="true"></span>
                </span>
              </div>
            </div>
            : null
          }

          {
            !this.state.videoPlaying
            ?
              <div className="theme-infobar">
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.genre)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.genreInfo)}</div>
                  <div className="theme-infobar-icon"><img src={MagnifierIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.difficulty)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.difficultyInfo)}</div>
                  <div className="theme-infobar-icon"><img src={StarIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.players)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.playersInfo)}</div>
                  <div className="theme-infobar-icon"><img src={PlayerIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.language)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.languageInfo)}</div>
                  <div className="theme-infobar-icon"><img src={GlobeIcon} alt="" /></div>
                </div>
              </div>
            : null
          }
        </div>
        <div className="theme-presentation-text-wrapper">
          <div className="theme-presentation-text">
		    <h1>{formatMessage(messages.titreh1)}</h1>
            <p>{formatMessage(messages.presentationText1)}</p>
            <p>{formatMessage(messages.presentationText2)}</p>
            <p>{formatMessage(messages.presentationText3)}</p>
            <div className="theme-presentation-disclaimer">
              <img alt="" src={FearEmoji} />
              <span>{formatMessage(messages.disclaimer)}</span>
            </div>
          </div>
        </div>
        <div className="theme-gallery-container">
          <span className="theme-gallery-label">{formatMessage(messages.gallery)}</span>
          <div className="theme-gallery">
            <div className="theme-gallery-testimonial">
              <p className="theme-gallery-testimonial-comment">{formatMessage(messages.testimonalComment)}</p>
              <p className="theme-gallery-testimonial-author">
                <span>{formatMessage(messages.testimonalAuthor)}</span>
                <span className="theme-gallery-testimonial-source">Tripadvisor</span>
              </p>
            </div>
            <div
              className="theme-gallery-image theme-gallery-video"
              style={{backgroundImage: `url(${LAVideo2})`}}
              >
              {
                this.state.smallVideoPlaying
                ?
                  <DeferredYouTubePlayer videoId="f7LECKNbm-U" title="Trailer Lost Asylum" />
                : <div style={{ width: "100%", height: "100%", position: "relative"}}>
                    <span
                      className="theme-gallery-play-button"
                      onClick={() => this.setState({ smallVideoPlaying: true })}
                      >►</span>
                  </div>
              }
              </div>
            <div
              style={{backgroundImage: `url(${LAPicture1})`}}
              className="theme-gallery-image theme-gallery-picture-1"></div>
            <div
              style={{backgroundImage: `url(${LAPicture2})`}}
              className="theme-gallery-image theme-gallery-picture-2"></div>
            <div
              style={{backgroundImage: `url(${LAPicture3})`}}
              className="theme-gallery-image theme-gallery-picture-3"></div>
          </div>
        </div>
        <BookingContainer
		  theme="la"
          lang={this.props.lang}
          expiration={() => this.props.handleExpiration()}
        />
        <RoomSeoSection room="lostAsylum" lang={this.props.lang} />
        <div className="theme-video-pack-note">
          <h2>{formatMessage(messages.videoPackTitle)}</h2>
          <p>
            {formatMessage(messages.videoPackText)}
            <Link to="/pack-video/">{formatMessage(messages.videoPackLink)}</Link>
          </p>
        </div>
        <div className="theme-other-themes">
          <h3>{formatMessage(messages.discoverOurOtherThemes)}</h3>
          <div className="theme-other-themes-container">
            <Link to="/abattoir/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${AbattoirPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.slaughterhouse)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.slaughterhouseBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/very-bad-night/">
              <div className="theme-other-themes-card theme-other-themes-card--vbn">
                <div className="theme-other-themes-picture theme-other-themes-card--vbn" style={{ backgroundImage: `url(${VBNPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.VBN)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.VBNBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/yakuza/">
              <div className="theme-other-themes-card theme-other-themes-card--yakuza">
                <div className="theme-other-themes-picture theme-other-themes-card--yakuza" style={{ backgroundImage: `url(${YakuzaPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.yakuza)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.yakuzaBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/expedition-maudite/">
              <div className="theme-other-themes-card theme-other-themes-card--tombeau">
                <div className="theme-other-themes-picture theme-other-themes-card--tombeau" style={{ backgroundImage: `url(${TombeauPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.tombeau)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.tombeauBase)}</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

const messages = defineMessages({
  playVideo: {
    id: 'themes.playVideo',
    defaultMessage: 'Lancer la vidéo'
  },
  genre: {
    id: 'themes.genre',
    defaultMessage: 'Genre'
  },
  difficulty: {
    id: 'themes.difficulty',
    defaultMessage: 'Difficulté'
  },
  players: {
    id: 'themes.players',
    defaultMessage: 'Joueurs'
  },
  language: {
    id: 'themes.language',
    defaultMessage: 'Langue'
  },
  genreInfo: {
    id: 'la.genre',
    defaultMessage: 'Peur / Suspens'
  },
  difficultyInfo: {
    id: 'la.difficulty',
    defaultMessage: 'Tous niveaux'
  },
  playersInfo: {
    id: 'la.players',
    defaultMessage: 'de 2 à 5 joueurs'
  },
  languageInfo: {
    id: 'la.language',
    defaultMessage: 'Français / Anglais'
  },
  titreh1: {
    id: 'la.titreh1',
    defaultMessage: 'Escape game épouvante à Paris'
  },
  presentationText1: {
    id: 'la.presentationText1',
    defaultMessage: '1952, un hôpital psychiatrique vient de fermer ses portes suite à un fait divers sanglant : un patient interné depuis de nombreuses années vient d’assassiner plusieurs médecins dans des circonstances encore inexpliquées. Depuis, on ne l’a jamais revu.'
  },
  presentationText2: {
    id: 'la.presentationText2',
    defaultMessage: 'Le temps a passé, et les vieux murs gardent leurs secrets, les cris résonnent encore, suintent de la souffrance accumulée, et de folles rumeurs circulent...'
  },
  presentationText3: {
    id: 'la.presentationText3',
    defaultMessage: 'Ceux qui ont eu la curiosité de s’approcher rapportent des faits étranges. Que se passe-t-il dans ce bâtiment abandonné ?'
  },
  disclaimer: {
    id: 'la.disclaimer',
    defaultMessage: 'Attention, des éléments du jeu peuvent surprendre ou effrayer. Déconseillé aux âmes sensibles'
  },
  videoPackTitle: {
    id: 'la.videoPackTitle',
    defaultMessage: 'Gardez un souvenir de votre session'
  },
  videoPackText: {
    id: 'la.videoPackText',
    defaultMessage: "Lost Asylum peut être joué avec l'option pack vidéo : nous préparons un montage souvenir d'environ 10 minutes avec plusieurs moments forts de votre partie, envoyé par email sous 48 heures après la session. "
  },
  videoPackLink: {
    id: 'la.videoPackLink',
    defaultMessage: 'En savoir plus sur le pack vidéo.'
  },
  gallery: {
    id: 'themes.gallery',
    defaultMessage: 'Galerie'
  },
  testimonalComment: {
    id: 'la.testimonalComment',
    defaultMessage: 'Un détour mortel...lement fun ! Aucun temps mort, plusieurs pièces, des énigmes retordes, très différentes et surtout bien trouvées.'
  },
  testimonalAuthor: {
    id: 'la.testimonalAuthor',
    defaultMessage: '13ludwigd, Paris, France'
  },
  discoverOurOtherThemes: {
    id: 'themes.discoverOurOtherThemes',
    defaultMessage: 'Découvrez nos autres thèmes escape game Paris :'
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: 'ça va trancher chérie'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  VBNBaseline: {
    id: 'themesContainer.vbnBaseline',
    defaultMessage: "Une gueule de bois marathon"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  yakuzaBaseline: {
    id: 'themesContainer.yakuzaBaseline',
    defaultMessage: "Une gueule de bois marathon"
  },
  lostAsylum: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  lostAsylumMeta: {
    id: 'themes.laMeta',
    defaultMessage: "Lost Asylum"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  tombeauBaseline: {
    id: 'themesContainer.tombeauBase',
    defaultMessage: "L'aventure à la Indiana Jones"
  },
  tombeauBase: {
    id: 'themesContainer.tombeauBase',
    defaultMessage: "L'aventure à la Indiana Jones"
  },
})

export default injectIntl(LostAsylum)



// WEBPACK FOOTER //
// ./src/components/LostAsylum.js